<template>
  <div class="drawer" style="height: calc(100vh - 60px);">
    <div v-show="isHistoryShow" class="drawer-meng" @click="isHistoryShow = false"></div>
    <CommonSearch
      ref="CommonSearch"
      style="border-bottom:none"
      :search-label="searchLabel"
      :show-history-dialog="isHistoryShow"
      @showHistory="isHistoryShow = true"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    ></CommonSearch>
    <!-- <CompanySearch ref="CommonSearch"
                  style="border-bottom:none"
                  :search-label="searchLabel"
                  :show-history-dialog="isHistoryShow"
                  @showHistory="isHistoryShow=true"
                  @doSearch="defaultSearch"
                  @changeSearchType="changeSearchType"></CompanySearch> -->

    <div v-if="isSearch" v-loading="loading" class="drawer-content">
      <CompanyList
        :companies="searchCompanies"
        :company="company"
        :fold="companyListFold"
        @modifyFold="modifyFold"
        @chooseCompany="getCompanyDetail"
      ></CompanyList>
    </div>
    <div v-if="company._id" class="drawer-content">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-item" style="cursor:pointer" @click.native="activeTag = ''">
            <div style="display:inline-block">
              <i class="el-icon-office-building breadcrumb-icon" style="transform: translateY(3px);"></i>
              <span style="color:#262626;font-weight:600;">公司信息</span>
            </div>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeTag" class="breadcrumb-item">{{ translateTag[activeTag]||activeTag }}</el-breadcrumb-item>
        </el-breadcrumb>
        <span v-if="activeTag==='快速介绍公司'" class="svg-text-btn" @click="activeTag = ''">
          <svg t="1621590925010" fill="#409EFF" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17885" width="12" height="12"><path d="M728.1 376H125l293.3-260.7c14.2-12.6 15.5-34.4 2.9-48.6-12.6-14.2-34.3-15.5-48.6-2.9L13.1 383.4c-8 6.3-13.1 16-13.1 27V412.1c0.4 9.2 4.6 17.9 11.5 24l361 320.9c6.6 5.8 14.7 8.7 22.8 8.7 9.5 0 18.9-3.9 25.7-11.5 12.6-14.2 11.3-35.9-2.9-48.6L124.8 444.8H728.2c125.2 0 227 101.8 227 227s-101.8 227-227 227H331.6c-19 0-34.4 15.4-34.4 34.4s15.4 34.4 34.4 34.4h396.5c163.1 0 295.8-132.7 295.8-295.8C1023.9 508.7 891.2 376 728.1 376z m0 0" p-id="17886"></path></svg>
          返回
        </span>
        <span v-if="activeTag==='薪酬职级'" class="svg-text-btn" type="text" @click="changeSearchType('行业薪酬')">
          <svg t="1621844337690" fill="#409EFF" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11003" width="12" height="12"><path d="M490.666667 117.333333a32 32 0 0 1 3.072 63.850667L490.666667 181.333333H192a10.666667 10.666667 0 0 0-10.496 8.746667L181.333333 192v640a10.666667 10.666667 0 0 0 8.746667 10.496L192 842.666667h640a10.666667 10.666667 0 0 0 10.496-8.746667L842.666667 832V533.333333a32 32 0 0 1 63.850666-3.072L906.666667 533.333333v298.666667a74.666667 74.666667 0 0 1-70.570667 74.56L832 906.666667H192a74.666667 74.666667 0 0 1-74.56-70.570667L117.333333 832V192a74.666667 74.666667 0 0 1 70.570667-74.56L192 117.333333h298.666667z m341.333333 0a74.666667 74.666667 0 0 1 74.56 70.570667L906.666667 192v128a32 32 0 0 1-63.850667 3.072L842.666667 320v-77.226667A781.781333 781.781333 0 0 0 455.168 627.2a32 32 0 1 1-58.112-26.816A845.738667 845.738667 0 0 1 823.296 181.333333H704a32 32 0 0 1-3.072-63.850666L704 117.333333h128z" p-id="11004"></path></svg>
          行业薪酬
        </span>

      </div>
      <div v-if="showCompanyTag" class="mb10">
        <CompanyDetailToTag
          ref="CompanyDetailToTag"
          :company="company"
          :active-tag="activeTag"
          @chooseTag="chooseTag"
        ></CompanyDetailToTag>
      </div>
      <div v-if="activeTag">
        <BasicInfo v-if="activeTag === '公司评级'" ref="BasicInfo" :company="company"></BasicInfo>
        <QuickIntro v-else-if="activeTag === '快速介绍公司'" ref="QuickIntro" :company="company" @quickEdit="quickEdit"></QuickIntro>
        <Intro v-else-if="activeTag === '公司简介'" ref="Intro" :company="company"></Intro>
        <Advantage v-else-if="activeTag === '优势/劣势'" ref="Advantage" :company="company" @quickEdit="quickEdit"></Advantage>
        <Character v-else-if="activeTag === '特点/风格'" ref="Character" :company="company" @quickEdit="quickEdit"></Character>
        <Special v-else-if="activeTag === '推荐须知'" ref="Special" :company="company"></Special>
        <RadishLike v-else-if="activeTag === '用人偏好'" ref="RadishLike" :company="company" @openCompany="(v)=>openCompany(v)"></RadishLike>
        <Interview v-else-if="activeTag === '面试相关'" ref="Interview" :company="company" @quickEdit="quickEdit"></Interview>
        <Salary v-else-if="activeTag === '薪酬职级'" ref="Salary" :company="company" @quickEdit="quickEdit"></Salary>
        <Leader v-else-if="activeTag === '领军人物'" ref="Leader" :company="company" @quickEdit="quickEdit"></Leader>
        <Attachment v-else-if="activeTag === '公司附件'" ref="Attachment" :company="company"></Attachment>
        <AlphaCognize v-else-if="activeTag === '阿尔法认知'" ref="AlphaCognize" :company="company" @quickEdit="quickEdit"></AlphaCognize>
        <CategoryCognize v-else-if="activeTag === '职能模块认知'" ref="CategoryCognize" :company="company" @quickEdit="quickEdit"></CategoryCognize>
        <!-- <RadishPicAnalyse v-else-if="activeTag === '人才画像分析'" ref="RadishPicAnalyse" :company="company"></RadishPicAnalyse> -->
        <NewRadishPicAnalyse v-else-if="activeTag === '人才画像分析'" ref="NewRadishPicAnalyse" :company="company"></NewRadishPicAnalyse>
        <QandA v-else-if="activeTag === '问题及应对'" ref="QandA" :company="company" @quickEdit="quickEdit"></QandA>
        <div class="edit-btn-box">
          <el-button size="mini" @click="toCompany">编辑</el-button>
          <!-- <span class="radish-btn radish-btn-primary radish-btn-small" @click="toCompany">编辑</span> -->
        </div>
      </div>

      <!-- <div class="default-company">
          <p>您要找的是不是以下公司：</p>
          <p v-for="company in defaultCompany"
            :key="company"
            class="link-item"
            @click="search({type:'公司',keywords:company})">
            {{`${company}`}}
          </p>
        </div> -->
    </div>
    <div v-if="company._id && !activeTag" style="padding: 0 25px;">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-item">
            <div style="display:inline-block">
              <i class="el-icon-document-copy breadcrumb-icon" style="transform: translateY(3px);"></i>
              <span style="color:#262626;font-weight:600;">客户公司的项目</span>
            </div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="padding-left: 10px;">
        <p v-for="project in companyProjects" :key="project._id" class="link-item" @click="openProject(project)">
          {{ `${project.部门 ? `${project.部门}-` : ''}${project.项目名称}（${project.客户公司}）` }}
        </p>
      </div>
    </div>
    <EditDialog ref="EditDialog"></EditDialog>
  </div>
</template>
<script>
import { searchLabel2Value, searchPlaceHolder } from '../../constant/utils'
import CommonSearch from '../../searchBar/CommonSearch'
import CompanyList from './companyList'
import CompanyDetailToTag from './CompanyDetailToTag'
import BasicInfo from './BasicInfo'
import Intro from './Intro'
import Advantage from './Advantage'
import Character from './Character'
import Special from './Special'
import RadishLike from './RadishLike'
import Interview from './Interview'
// import Salary from './Salary'
import Salary from './NewSalary'
import Leader from './Leader'
import Attachment from './Attachment'
import AlphaCognize from './AlphaCognize'
import CategoryCognize from './CategoryCognize'
// import RadishPicAnalyse from './RadishPicAnalyse'
import QuickIntro from './QuickIntro'
import NewRadishPicAnalyse from './NewRadishPicAnalyse'
import QandA from './QandA'
import EditDialog from './EditDialog'

// 跳转到公司详情页面时的相应的快速导航页的名字
const navMap = {
  公司简介: '公司简介',
  阿尔法认知: '阿尔法认知',
  职能模块认知:'职能模块认知',
  '优势/劣势': '优势/劣势',
  特殊要求: '特殊要求',
  用人偏好: '用人偏好',
  面试相关: '面试相关',
  薪酬机制: '薪酬机制',
  领军人物: '领军人物',
  '特点/风格': '业务特点/人员风格',
  公司附件: '公司附件',
}
const translateTag = {
  公司简介: '公司介绍',
}
const searchLabel = '公司'
export default {
  components: {
    CommonSearch,
    CompanyList,
    CompanyDetailToTag,
    BasicInfo,
    Intro,
    Advantage,
    Character,
    Special,
    RadishLike,
    Interview,
    Salary,
    Leader,
    Attachment,
    AlphaCognize,
    CategoryCognize,
    // RadishPicAnalyse,
    QuickIntro,
    NewRadishPicAnalyse,
    QandA,
    EditDialog,
  },
  data: function() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
      placeHolder: searchPlaceHolder[searchLabel],
      isHistoryShow: false,
      searchCompanies: [],
      company: {},
      isSearch: false,
      loading: false,
      companyListFold: false,
      activeTag: '',
      showCompanyTag: true,
      companyProjects: [],
      translateTag:translateTag,
      tableFields: [
        {
          children: [
            { label: '地域', field: '地域' },
            { label: '业绩', field: '业绩' },
            { label: '专业能力', field: '专业能力' },
          ],
        },
        {
          children: [
            { label: '性别', field: '性别' },
            { label: '稳定性', field: '稳定性' },
            { label: '语言能力', field: '语言能力' },
          ],
        },
        {
          children: [
            { label: '年龄', field: '年龄' },
            { label: '来源公司', field: '来源公司' },
            { label: '领导能力', field: '领导能力' },
          ],
        },
        {
          children: [
            { label: '学历要求', field: '学历要求' },
            { label: '来源行业', field: '来源行业' },
            { label: '心态/性格', field: '心态/性格' },
          ],
        },
        {
          children: [
            { label: '学历标签', field: '学历标签' },
            { label: '平台', field: '平台' },
            { label: '个人风格', field: '个人风格' },
          ],
        },
        {
          children: [
            { label: '工作经验', field: '工作经验' },
            { label: '', field: '' },
            { label: '', field: '' },
          ],
        },
      ],
    }
  },
  // watch: {
  //   activeTag(newValue, oldValue) {
  //     this.showCompanyTag = !newValue
  //   },
  // },
  mounted() {
    this.init()
    const fields = []
    const { tableFields } = this
    tableFields.forEach(tr => {
      tr.children.forEach(td => {
        if (td.label) fields.push(td.field)
      })
    })
    this.analyseFields = fields
  },
  methods: {
    init() {
      this.keywords = ''
      this.result = []
      this.loading = false
    },
    goBack() {
      this.$emit('goBack')
    },
    quickEdit(params){
      this.$refs.EditDialog.open(params)
    },
    async getRadishes(rids) {
      if (!rids) return null
      const res = await app.service('radish').simpleList({
        query: { _id: { $in: rids } },
        fields: { 姓名: 1 },
      })
      return res.status === 'success' ? res.data : null
    },
    chooseTag(tag) {
      this.activeTag = tag
      if (tag === '组织架构') {
        window.open(`${window.origin}#/company/${this.company._id}?activeTab=CompanyRadishes&secondActiveTab=Structure`)
      }
    },
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    setSearchHistory() {
      this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
      if (!this.searchHistory[this.searchType]) this.searchHistory[this.searchType] = []
      if (!this.searchHistory[this.searchType].includes(this.keywords)) {
        this.searchHistory[this.searchType].unshift(this.keywords)
        localStorage.searchHistory = JSON.stringify(this.searchHistory)
      }
    },
    async doSearch() {
      if (!this.keywords) return this.$message.info('请输入搜索内容')
      this.setSearchHistory()
      this.isHistoryShow = false
      this.loading = true
      try {
        await app.service('misc').insertSearchHistory({ type: searchLabel, keywords: this.keywords })
      } catch (e) {}
      const typesMap = { 重点客户: 1, 客户公司: 2, 目标客户: 3 }
      const res = await app.service('company').serchCompany(this.keywords)
      if (res.status === 200) {
        this.isSearch = true
        this.searchCompanies = res.data.sort((a, b) => {
          if (b.签约 === '已签约' && a.签约 !== '已签约') return 1
          if (!a.公司类型 && b.公司类型) return 1
          if (a.公司类型 && b.公司类型 && typesMap[b.公司类型] < typesMap[a.公司类型]) return 1
          return -1
        })
        if (this.searchCompanies.length !== 0) {
          const val = this.searchCompanies.find(v => v.简称 === this.keywords || v.公司名称 === this.keywords)
          this.getCompanyDetail({ id: val ? val._id : this.searchCompanies[0]._id, type: 'auto' })
        }
      } else this.$message.error(res.msg)
      this.loading = false
    },
    defaultSearch({ type, keywords, result }) {
      this.searchType = type
      this.keywords = keywords
      this.$refs.CommonSearch.keywords = keywords
      if (result) {
        this.result = result
      } else {
        this.$nextTick(() => {
          this.doSearch()
        })
      }
    },
    openCompany(name){
      this.defaultSearch({type:'公司',keywords:name})
    },
    async getCompanyDetail({ id, type }) {
      const ind = this.searchCompanies.findIndex(v=>v._id===id)
      const obj = this.searchCompanies[ind]
      this.searchCompanies.splice(ind,1)
      this.searchCompanies.unshift(obj)
      const res = await app.service('company').serchCompanyDetail(id)
      if (res.status === 200) {
        if (Array.isArray(res.data.典型人才) && res.data.典型人才.length > 0) {
          res.data.典型人才 = await this.getRadishes(res.data.典型人才)
        }
        this.company = res.data
        // this.init()
        this.companyListFold = type !== 'auto'
        this.showCompanyTag = true
        this.activeTag = ''
        this.getCompanyProject(this.company.简称)
        this.getComCateCognition(this.company._id)
        this.getCompanyStatistics()
        // try {
        //   this.computedTags()
        // } catch (error) {
        //   console.log(error.stack)
        // }
        // this.toshowtag('基本信息')
      } else this.$message.error(res.msg)
    },
    async getCompanyProject(company) {
      const res = await app.service('misc').defaultCompanyProject({ company })
      if (res.status === 'success') this.companyProjects = res.data
      else this.$message.error(res.msg)
    },
    async getComCateCognition(){
      const res = await app.service('company').getComCateCognition(this.company._id)
      if (res.status === 'success') {
        res.data.forEach(element => {
          if (element.logs && element.logs.length > 0) {
            element.logs.sort((a, b) => b.createdAt - a.createdAt)
          }
        })
        this.$set(this.company,'职能模块认知',res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCompanyStatistics(){
      const option = { cid: this.company._id }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        const radishImage = (res.data && res.data[0]) || {}
        const obj = {}
        this.analyseFields.forEach(v => {
          obj[v] = this.radishImageTemplate(radishImage, v)
        })
        // this.analyse = obj
        this.$set(this.company,'analyse',obj)
      }
    },
    radishImageTemplate(radishImage, item) {
      const val = radishImage[item]
      if (!val) return ''
      if (val['统计'] && val['统计'][0] && val['统计'][0][0] === '未知' && val['统计'][1]) {
        return `${val['统计'][1][0]}（${(val['统计'][1][2] * 100).toFixed(1)}%）`
      }
      return ''
    },
    openProject(project) {
      this.$emit('drawerLoad', { type: '项目', keywords: project.项目名称, id:project._id })
      // window.open(`${window.origin}/#/project20/${project._id}?defaultActiveTab=详情`)
    },
    modifyFold() {
      this.companyListFold = !this.companyListFold
    },
    toCompany() {
      window.open(
        `${window.origin}#/company/${this.company._id}?activeTab=ClientPic&isEdit=true`,
      )
    },
  },
}
</script>
<style>
.breadcrumb .el-breadcrumb {
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
<style scoped>
.breadcrumb {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.svg-text-btn{
  cursor: pointer;
  color: #409eff;
  display: flex;
  align-items: center;
}
.edit-btn-box {
  display: flex;
  padding: 0 10px 10px;
  justify-content: flex-end;
}
.link-item {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  color: #409eff;
  cursor: pointer;
}
.breadcrumb-item {
  line-height: 20px;
}
</style>
<style scoped src="../../constant/css/drawer.css"></style>
